import { Trans, useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    Caption,
    Flex,
    Stack,
} from '@myphx-engineering/phx-design-system';

import { useFlags } from '../../../hooks/use-flags';
import { hasAdditionalShippingOptions } from '../../../util';

import { DeliveryStep } from './DeliveryStep';
import type { LocationInfo } from './shared';

export const MailOrderNextSteps = ({
    locationInfo,
}: {
    locationInfo: LocationInfo;
}) => {
    const { t } = useTranslation();
    const { costPlusDrugsEnabled } = useFlags();

    return (
        <Stack gap="sm">
            {locationInfo.url ? (
                <Stack gap="sm">
                    <DeliveryStep
                        stepTexts={[
                            {
                                key: 'orderConfirmation.mailOrderUrl.stepOne',
                                value: (
                                    <Flex align="start" py="xxs">
                                        <Trans
                                            i18nKey="orderConfirmation.mailOrderUrl.stepOne"
                                            values={{
                                                locationName: locationInfo.name,
                                            }}
                                        >
                                            <Body1>
                                                1. Sign in or sign up to{' '}
                                                <Anchor
                                                    href={locationInfo.url}
                                                    target="_blank"
                                                >
                                                    {locationInfo.name}
                                                </Anchor>
                                            </Body1>
                                        </Trans>
                                    </Flex>
                                ),
                            },
                            hasAdditionalShippingOptions(locationInfo.name) &&
                            costPlusDrugsEnabled
                                ? t(
                                      'orderConfirmation.mailOrderUrl.stepTwoCostPlusDrugs'
                                  )
                                : t('orderConfirmation.mailOrderUrl.stepTwo'),
                        ]}
                    />
                </Stack>
            ) : (
                <Stack gap="sm">
                    <Body1>
                        {t('orderConfirmation.mailOrderPhone.pharmacyContact')}
                    </Body1>
                    <DeliveryStep
                        stepTexts={[
                            t('orderConfirmation.mailOrderPhone.stepOne'),
                            t('orderConfirmation.mailOrderPhone.stepTwo'),
                        ]}
                    />
                </Stack>
            )}
            {costPlusDrugsEnabled && (
                <Caption>{t('orderConfirmation.mailOrder.disclaimer')}</Caption>
            )}
        </Stack>
    );
};
